function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { DropdownItem, highlightMenuItem } from './menu';
import { size8, size12 } from '../../theme/scale';
import * as COLORS from '../../theme/colors';
import { fontBold, fontBuenosAiresRegular } from '../../theme/fonts';
const DropdownItemLabel = styled.span`
  ${({
  context,
  showContext
}) => context && showContext && `margin-right: ${size8};`}

  ${({
  joyableTheme
}) => joyableTheme ? `
      font-family: ${fontBuenosAiresRegular};
    ` : `> b {
      font-family: ${fontBold};
    }`}
`;
const DropdownItemContext = styled.span`
  color: ${({
  color
}) => color ? COLORS[color] : COLORS.gray600};
  font-size: ${size12};
  white-space: nowrap;
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
const DropdownLabel = ({
  item,
  inputValue,
  joyableTheme,
  searchable,
  showContext
}) => {
  if (!inputValue || !searchable) return /*#__PURE__*/React.createElement(DropdownItemLabel, {
    joyableTheme: joyableTheme,
    context: !!item.context,
    showContext: showContext
  }, item.label);
  return /*#__PURE__*/React.createElement(DropdownItemLabel, {
    dangerouslySetInnerHTML: {
      __html: highlightMenuItem(item.label, inputValue)
    }
  });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
const ItemList = ({
  items,
  size,
  inputValue,
  searchable,
  showContext,
  joyableTheme
}) => /*#__PURE__*/React.createElement(React.Fragment, null, items.map(item => /*#__PURE__*/React.createElement(DropdownItem, _extends({
  "aria-label": item.ariaLabel,
  "data-testid": "dropdown-item",
  key: item.props.id
}, item.props, {
  joyableTheme: joyableTheme,
  size: size
}), /*#__PURE__*/React.createElement(DropdownLabel, {
  searchable: searchable,
  item: item,
  inputValue: inputValue,
  showContext: showContext,
  joyableTheme: joyableTheme
}), item.context && showContext && /*#__PURE__*/React.createElement(DropdownItemContext, {
  color: item.contextColor
}, item.context))));
export default ItemList;
//# sourceMappingURL=item-list.js.map